import React from 'react';
import CommonWelcomeAdd from '../../../components/Welcome/CommonWelcomeAdd';
import CommonWelcomeList from '../../../components/Welcome/CommonWelcomeList';

const WelcomeOutList = () => {
    return (
        <CommonWelcomeList
            pageName='Pazarlama > Karşılamalar > Antrepo Tahliye'
            isOut={true}
            isIn={false}
        />
    )
}

export default WelcomeOutList;